/**
 * functions and helpers for querying and working with watershed data
 */

import { watershedPolygon as watershedColor } from '@/functions/appColors';

export default {
    methods: {
        /**
         * add map source and layer for the watershed polygon
         * the layer will update as the source data is changed
         */
        async addWatershedLayer(layerAbove) {
            const map = await this.mapPromise;

            // start with an empty source
            map.addSource('watershed-polygon', {
                type: 'geojson',
                data: null,
            });

            map.addLayer({
                id: 'watershed-polygon',
                type: 'fill',
                source: 'watershed-polygon',
                paint: {
                    'fill-color': String(watershedColor),
                    'fill-opacity': 0.5,
                },
            });

            // move the layer below layerAbove, if specified
            if (layerAbove) {
                map.moveLayer('watershed-polygon', layerAbove);
            }
        },
        /**
         * get the query search distance from the map zoom level
         * @param  {[type]} zoom [description]
         * @return {[type]}      [description]
         */
        getSearchDistance(zoom) {
            let searchDistance = 5000;
            let intZoom = Math.floor(zoom);
            // check zoom level within the range below
            if (intZoom > 13) {
                intZoom = 13;
            } else if (intZoom < 7) {
                intZoom = 7;
            }
            // Set the search distance based on the zoom level
            switch (intZoom) {
            case 7:
                searchDistance = 5000;
                break;
            case 8:
                searchDistance = 1000;
                break;
            case 9:
                searchDistance = 750;
                break;
            case 10:
                searchDistance = 500;
                break;
            case 11:
                searchDistance = 200;
                break;
            case 12:
                searchDistance = 150;
                break;
            case 13:
                searchDistance = 100;
                break;
            default:
                searchDistance = 5000;
                break;
            }
            return searchDistance;
        },
        /**
         * clear the watershed polygon
         * by setting the source data to an empty feature
         * note that this doesn't remove the source or the layer
         */
        async clearWatershedPolygon() {
            const map = await this.mapPromise;
            const source = map.getSource('watershed-polygon');
            source.setData({
                type: 'Point',
                coordinates: [],
            });
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/watershedData.js